import React, { Component } from "react";
import SideBar from "components/common/SideBar";
import { investorsRoutes } from "Routes";
import NavBar from "components/common/NavBar";
import Footer from "components/common/Footer";
import { Router } from "@reach/router";
import Portfolio from "components/InvestorComponents/Portfolio";
import SeeDeals from "components/InvestorComponents/SeeDeals";
import Profile from "components/InvestorComponents/Profile";
export default class InvestorDashboard extends Component {
  componentDidMount() {
    // Store.dispatch({ type: "toggleLoad" });
    // Api.getUserNotifications().then(response => {
    //   Store.dispatch({ type: "toggleLoad" });
    //   Store.dispatch({
    //     type: "AddNotification",
    //     payload: response.data
    //   });
    // });
  }

  render() {
    return (
      <div className="App">
        <div className="wrapper">
          <SideBar links={investorsRoutes} />
          <div className="main-panel">
            <NavBar authenticated={true} />
            <div className="content">
              <div className="container-fluid">
                <Router>
                  {/* <Portfolio path="/" /> */}
                  <SeeDeals path="/" />
                  <Profile path="/profile" />
                  {/* <ListMyDeals path="/listmydeals" /> */}
                </Router>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}
